module.exports = __webpack_public_path__ + "static/media/moto_2.587626e1.png";